import { useEffect, useState } from 'react';
import styles from './InputPopup.module.css';

/* PROPS
content
positionAboveParent
saveContent (function)
*/

const InputPopup = (props) => {
  const [content, setContent] = useState(props.content);

  useEffect(() => {
    // setContent(props.content);
  }, [props]);

  let additionalProps = {};
  if (props.maxLength) {
    additionalProps["maxLength"] = props.maxLength;
  } 
  // const changeTextareaHeight = (e) => {
  //   e.target.style.height = "inherit";
  //   e.target.style.height = `${e.target.scrollHeight}px`;
  // };

  console.log("content: ", content)

  if (content === null) {
    setContent("");
  }

  return (
    <div>
      <div className={styles.popup} style={props.positionAboveParent ? {top: "-8.2em"}: {top: "14px"}}>
        <textarea
          // onKeyDown={changeTextareaHeight}
          placeholder={props.placeholder}
          className={styles.inputField}
          value={content}
          {...additionalProps}
          autoFocus
          onChange={(e) => {
            setContent(e.target.value);
          }}
          // onBlur={props.saveContent}
        />
      </div>
      <div className={`${styles.backdrop}`} onClick={() => props.saveContent(content)}></div>
    </div>
  )
}

export default InputPopup;
    